export const COMPANY_LOGO_SIZE = {
    DESKTOP: 36,
    MOBILE: 40,
} as const;
